import React, { FunctionComponent } from "react"
import { FieldErrors } from "react-hook-form"
interface iTextareaProps {
  name?: string
  label?: string
  rows?: number
  placeholder?: string
  value?: string
  error?: FieldErrors
  onChange?: (value: string) => void
}

const Textarea: FunctionComponent<iTextareaProps> = ({
  name,
  label = "",
  placeholder,
  value = "",
  error,
  onChange,
  rows = 5,
}) => {
  return (
    <div className={`form-group`}>
      <label htmlFor={name}>
        {label} {error && <span>{error.message}</span>}
      </label>
      <div className="form-control">
        <textarea
          id={name}
          className={error ? "error" : ""}
          name={name}
          placeholder={placeholder}
          autoComplete="off"
          value={value}
          rows={rows}
          onChange={(e) => onChange && onChange(e.target.value)}
        />
      </div>
    </div>
  )
}

export default Textarea
